import React from "react";
import { createPortal } from "react-dom";
import { ToastContainer, Slide } from "react-toastify";
import styled from "styled-components";
import {useBoundStore} from "e3-common/store/useBoundStore";

const OverlayStyle = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    //background-color: rgba(0, 0, 0, 0.3);
    z-index: 9998;
    pointer-events: auto;
`;




const E3Toast = () => {
    const loading = useBoundStore((state) => state.toastAction.isLoading);

    const toastContainerStyle = (loading) => ({
        zIndex: 9999,
    });

    return createPortal(
        <>
            {loading && <OverlayStyle />}
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                transition={Slide}
                style={toastContainerStyle(loading)}

            />
        </>,
        document.body
    );
};

E3Toast.displayName = "E3Toast";

export default E3Toast;